module.exports = __webpack_public_path__ + "img/processing-01.06b72913.svg";